/*
 * fn: removeMediavineContainers
 *
 * Removes specific MediaVine containers for when ads are disabled
 *
 */
export const removeMediavineContainers = () =>
  document.querySelectorAll('#fixed_container_bottom').forEach((el) => el.remove())
